<template>
  <div :class="{ 'everythingmd': !md }" class="everything d-flex justify-center align-center">
    <div :class="{ contentmd: md }" class="content d-flex">
      <div :class="{ leftcardxs: md }" class="leftcard">
        <CardLeft
        :loadData="loadData"
          :ad="ad"
          class="full-height"
          :emoji="images[0]"
          title="IAQ"
          descTop="INDOOR AIR QUALITY"
          :value="aqi"
          :device="name"
          :update="info.dtm"
        />
      </div>
      <div
        :class="{ bottomcard: md, bottomcardmd: !md }"
        class="rightcard d-flex flex-column"
      >
        <div
          :class="{ topcardsmd: md }"
          class="topcards d-flex flex-row half-height"
        >
          <CardRight
            class="full-width"
            :emoji="images[1]"
            title="PM 1.0"
            descTop="µm"
            descBot="Fine Dust"
            :value="info.pm1"
            unit="µg/m³"
          />
          <CardRight
            class="full-width"
            :emoji="images[2]"
            title="PM 2.5"
            descTop="µm"
            descBot="Dust"
            :value="info.pm25"
            unit="µg/m³"
          />
        </div>
        <div
          :class="{ botcardsmd: md }"
          class="botcards d-flex flex-row half-height"
        >
          <CardRight
            class="full-width"
            :emoji="images[3]"
            title="PM 10"
            descTop="µm"
            descBot="Sand Dust"
            :value="info.pm10"
            unit="µg/m³"
          />
          <CardRight
            class="full-width"
            :emoji="images[4]"
            title="TVOC"
            descTop=""
            descBot = "Total Volatile Organic Compounds"
            :value="info.voc"
            unit="ppm"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CardLeft from "./CardLeft.vue";
import CardRight from "./CardRight.vue";

import axios from "axios";
export default {
  name: "HomeView",
  components: {
    CardLeft,
    CardRight,
  },
  data() {
    return {
      md: false,
      id: this.$route.params.id,
      info: undefined,
      test: "HEllo",
      images: [],
      ad: undefined,
      aqi: undefined,
      name: undefined
    };
  },
  async created() {
    this.loadData();
    setInterval(() => this.loadData(), 30000);
  },
  async mounted() {
    window.scrollTo(0, 10);
    setTimeout(window.scrollTo(0, 10), 100);
    this.handleResize();
    var elem = document.documentElement;
    if (elem.requestFullscreen) {
      await elem.requestFullscreen().catch((err) => {
        console.log(err);
      });
    } else if (elem.webkitRequestFullscreen) {
      /* Safari */
      await elem.webkitRequestFullscreen();
    } else if (elem.msRequestFullscreen) {
      /* IE11 */
      elem.msRequestFullscreen().catch((err) => {
        console.log(err);
      });
    }
    window.addEventListener("resize", this.handleResize);
  },
  unmounted() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    handleResize() {
      window.scrollTo(0, 10);
      this.md = window.matchMedia("(max-aspect-ratio:1/1)").matches
        ? true
        : false;
    },
    GetAQI(value) {
      if (value > 0 && value < 12) {
        return ((50 - 0) / (12 - 0)) * (value - 0) + 0;
      }
      if (value > 12.1 && value < 35.4) {
        return ((100 - 51) / (35.4 - 12.1)) * (value - 12.1) + 51;
      }
      if (value > 35.5 && value < 55.4) {
        return ((150 - 101) / (55.4 - 35.5)) * (value - 35.5) + 101;
      }
      if (value > 55.5 && value < 150.4) {
        return ((200 - 151) / (150.4 - 55.5)) * (value - 55.5) + 151;
      }
      if (value > 150.5 && value < 250.4) {
        return ((300 - 201) / (250.4 - 150.5)) * (value - 150.5) + 201;
      }
      if (value > 250.5 && value < 350.4) {
        return ((400 - 301) / (350.4 - 250.5)) * (value - 250.5) + 301;
      }
      if (value > 350.5 && value < 500.4) {
        return ((500 - 401) / (500.4 - 350.5)) * (value - 150.5) + 201;
      }
      return -1;
    },

    GetEmoji(
      value,
      minGood,
      maxGood,
      minModerate,
      maxModerate,
      minPolluted,
      maxPolluted,
      minVPolluted,
      maxVPolluted,
      minSPolluted,
      maxSPolluted
    ) {
      let h;
      if (value >= minGood && value <= maxGood) {
        console.log("yehhee haha");
        h = "./smilygood.png";
      }

      if (value >= minModerate && value <= maxModerate) {
        h = "./smilymoderate.png";
      }

      if (value >= minPolluted && value <= maxPolluted) {
        h = "./smilypolluted.png";
      }

      if (value >= minVPolluted && value <= maxVPolluted) {
        h = "./smilyvpolluted.png";
      }

      if (value >= minSPolluted && value <= maxSPolluted) {
        h = "./smilyspolluted.png";
      }
      return h;
    },
    async loadData() {
      const response = await axios.get("/" + this.id);
      this.name =response.data.name;
   
      this.info = response.data;
    
       //console.log( new Date().getTimezoneOffset())

      this.ad = response.data.image;
      if (this.ad == undefined) {
        this.ad = "./AD.jpg";
      }else
      {
        this.ad= axios.defaults.baseURL+"/"+this.ad;
      }
      this.info = this.info.data;
     this.info.dtm= this.info.dtm.replace("T"," ").replace("Z"," ");
      this.info.dtm=Date(Date.parse(this.info.dtm+ new Date().getTimezoneOffset())).split("G")[0];
      this.images = [];
      this.aqi = Math.trunc(this.GetAQI(this.info.pm25));
      console.log(this.images);
      let tmp = this.GetEmoji(
        this.aqi,
        0,
        50,
        51,
        100,
        101,
        150,
        151,
        200,
        201,
        500
      );
      this.images.push(tmp);
      tmp = this.GetEmoji(
        this.info.pm1,
        0,
        14,
        15,
        34,
        35,
        61,
        62,
        95,
        96,
        150
      );
      console.log(this.info.pm1);
      this.images.push(tmp);
      tmp = this.GetEmoji(
        this.info.pm25,
        0,
        20,
        21,
        50,
        51,
        90,
        91,
        140,
        141,
        200
      );
      this.images.push(tmp);
      tmp = this.GetEmoji(
        this.info.pm10,
        0,
        30,
        31,
        75,
        76,
        125,
        126,
        200,
        201,
        300
      );
      this.images.push(tmp);
      tmp = this.GetEmoji(
        this.info.voc,
        0,
        0.087,
        0.088,
        0.261,
        0.262,
        0.66,
        0.661,
        2.2,
        2.201,
        3
      );
      this.images.push(tmp);
      console.log(this.images);
    },
  },
};
</script>

<style>
.everything {
  padding: 0px 0 50px 0;
  min-height: calc(100vh + 10px);
  color: white;
  width: 100%;
  height: 100vh;
  background-color: #111;
  font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Roboto,
    Helvetica Neue, Arial, Noto Sans, Liberation Sans, sans-serif,
    Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color Emoji;
}
.everythingmd{
   padding: 0px 0 10px 0;
}
.content {
  height: 100%;
  width: 100%;
  padding: 1em;
  flex-flow: row;
}
.contentmd {
  height: 100%;
  width: 100%;
  padding: 0.35em;
  flex-flow: column;
}
.leftcard {
  height: 100%;
  width: 50%;
}
.leftcardxs {
  height: 60%;
  width: 100%;
}
.rightcard {
  height: 100%;
  width: 100%;
}
.rightcardmd {
  height: 100%;
  width: 100%;
  background-color: aqua;
}
.half-height {
  height: 50%;
  width: 100%;
}
.topcards {
  width: 100%;
  flex-wrap: nowrap;
  padding: 0 0 0.3em 0;
}
.topcardsmd {
  width: 100%;
  flex-wrap: nowrap;
  padding: 0 0 0.3em 0;
}
.botcards {
  width: 100%;
  flex-wrap: nowrap;
  padding: 0.3em 0 0 0;
}
.botcardsmd {
  width: 100%;
  padding: 0em 0 0 0;
}
.full-width {
  width: 100%;
}
.full-height {
  height: 100%;
  width: 100%;
}
.green {
  background-color: #00ffff;
  width: 100%;
  height: 20%;
}
.bottomcard {
  margin: 0;
}
.bottomcardmd {
  margin: 0;
}
</style>
